'use es6';

import { Record } from 'immutable';
import Networks from 'ads-account-connection/lib/Networks';
import { formatAdWordsAccountId } from 'ads-account-connection/lib/Utils';
export const ConnectedAccountStatuses = {
  ERROR: 'ERROR',
  CONNECTED: 'CONNECTED',
  INACTIVE: 'INACTIVE'
};
const DEFAULTS = {
  adAccountId: null,
  adNetwork: null,
  connected: null,
  currencyCode: null,
  name: null,
  trackingEnabled: null,
  enabled: true,
  status: null,
  connectedAccountStatus: null,
  currentUserHasConnected: null,
  networkUserId: null
};

class AvailableAdAccountRecord extends Record(DEFAULTS) {
  constructor(availableAccount, connectedAdAccounts, currentUserHasConnected) {
    const foundAccount = connectedAdAccounts.find(adAccount => availableAccount.adNetwork === adAccount.network && adAccount.accountId === availableAccount.adAccountId.toString());
    const connectedAccountStatus = !foundAccount ? null : !foundAccount.accessibleToPrimaryUser ? ConnectedAccountStatuses.ERROR : foundAccount.status !== 'ACTIVE' ? ConnectedAccountStatuses.INACTIVE : ConnectedAccountStatuses.CONNECTED;
    super(Object.assign({}, availableAccount, {
      trackingEnabled: !!foundAccount && foundAccount.trackingEnabled,
      connectedAccountStatus,
      currentUserHasConnected
    }));
  }

  getFormattedId() {
    return this.adNetwork === Networks.ADWORDS ? formatAdWordsAccountId(this.adAccountId) : this.adAccountId;
  }

  get accountId() {
    return this.adAccountId;
  }

}

export default AvailableAdAccountRecord;